import Config from 'services/config/config';
import callWebService, { callTypes } from 'services/utils/networks/network';
import {
  SITE_INSPECTION_GATE,
  SITE_INSPECTION_GATE_SOLUTION,
  LOCATION_APPROVAL_PENDING,
  POC_LIST_BY_SITEID,
  CHECK_LOCATION,
  GATE_DETAIL,
  SITE_INSPECTION_CHECKLIST,
  SITE_CARNIVAL_CHECKLIST,
  SITE_CARNIVAL_CHECKLIST_FILLED,
  SITE_CONSUMABLE_ITEMS
} from './type';

export const getSiteInspect = (id, stage_id) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.installation.siteInspectionStage}?site_id=${id}&stage_id=${stage_id}`
  );
  if (res) {
    const { data } = res;
    const siteData = data.response.data;
    dispatch({
      type: SITE_INSPECTION_GATE,
      payload: siteData,
    });
    return siteData;
  }
};

export const getGateDetail = (id, gateId) => async (dispatch) => {
  dispatch({
    type: GATE_DETAIL,
    payload: {},
  });
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.installation.gateDetail}?site_id=${id}&gate_id=${gateId}`
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: GATE_DETAIL,
      payload: data.response.data,
    });
    return true;
  }
};
// getSiteInspectSolution
export const getSiteInspectSolution = (id, stage_id) => async (dispatch) => {
  dispatch({
    type: GATE_DETAIL,
    payload: {},
  });
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.installation.siteInspectionStageSolution}?site_id=${id}&stage_id=${stage_id}`
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: SITE_INSPECTION_GATE_SOLUTION,
      payload: data.response.data,
    });
    return true;
  }
};

export const postSolution = (data) => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
    data,
    `${Config.installation.postSolution}`
  );
  if(res.data.response.data){
    console.log(res.data.response.data);
    return res.data.response.data;
  }else{
    return false;
  }
};

export const postSiteInspection = (data) => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
    data,
    `${Config.installation.saveSiteInformation}`
  );
  if (res) {
    return true;
  }
};

export const getLocationApprovalPending = (id, lat, long) => async (
  dispatch
) => {
  if (lat !== undefined && long !== undefined) {
    const res = await callWebService(
      callTypes.get,
      '',
      `${Config.installation.locationApprovalPending}?site_id=${id}&latitude=${lat}&longitude=${long}`
    );
    if (res) {
      const { data } = res;
      dispatch({
        type: LOCATION_APPROVAL_PENDING,
        payload: data.response.data,
      });
      return true;
    }
  }
};

export const getCheckLocation = (id, lat, long) => async (dispatch) => {
  if (lat !== undefined && long !== undefined) {
    const res = await callWebService(
      callTypes.get,
      '',
      `${Config.installation.checkChange}?site_id=${id}&latitude=${lat}&longitude=${long}`
    );
    if (res) {
      const { data } = res;
      dispatch({
        type: CHECK_LOCATION,
        payload: data.response.data,
      });
      return true;
    }
  }
};

export const getPocBySiteId = (id) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.installation.pocListBySite}?site_id=${id}`
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: POC_LIST_BY_SITEID,
      payload: data.response.data,
    });
    return true;
  }
};

export const postSendReportMail = (data) => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
    data,
    `${Config.installation.sendReportMail}`
  );
  if (res) {
    return true;
  }
};

export const getSiteInfoChecklist = (id, stageId, gateId) => async (dispatch) => {
  let filterQuery = "";
  if (gateId != null) {
    filterQuery = `&gate_id=${gateId}`;
  }
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.installation.getSiteInfoChecklist}?site_id=${id}&stage_id=${stageId}${filterQuery}`
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: SITE_INSPECTION_CHECKLIST,
      payload: data.response.data,
    });
    return true;
  }
};

export const getSiteCarnivalChecklist = (id, stage_id) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.installation.getSiteCarnivalChecklist}?site_id=${id}&stage_id=${stage_id}`
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: SITE_CARNIVAL_CHECKLIST,
      payload: data.response.data,
    });
    return true;
  }
};

export const postCarnivalData = (data) => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
    data,
    `${Config.installation.postCarnivalData}`
  );
  if(res) {
    const { data } = res;
    return data.response.status;
  }
};

export const getCarnivalCompletedDetails = (id, stage_id) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.installation.getCarnivalCompletedDetails}?site_id=${id}&stage_id=${stage_id}`
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: SITE_CARNIVAL_CHECKLIST_FILLED,
      payload: data.response.data,
    });
    return true;
  }
};

export const getSiteConsumablesItems = (comm_id) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.installation.getSiteConsumablesItems}?comm_id=${comm_id}`
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: SITE_CONSUMABLE_ITEMS,
      payload: data.response.data,
    });
    return true;
  }
};
export const updateSiteConsumesByOps = (data) => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
    data,
    `${Config.installation.updateSiteConsumesByOps}`
  );
  if(res) {
    const { data } = res;
    return data.response.status;
  }
};